export enum RuleTargetAction {
  HIDE = 'Hide',
  /**
   * Conditional presence: "Show X when Y" hides X whenever no SHOW rule for it matches, which is the
   * only way to express "only ask this sometimes". A matching SHOW also beats a HIDE on the same target,
   * but not a HIDE on the section a field sits in.
   */
  SHOW = 'Show',
  DISABLE = 'Disable',
  REQUIRE = 'Require',
  OPTIONAL = 'Optional'
}
